import { useForm, useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import styles from "../Cadastro.module.css";
import { Alert, Snackbar } from "@mui/material";
import UploadInput from "../../../../components/Inputs/UploadInput"
import servAnaliseProjeto from "../../../../services/login/servAnaliseProjeto";

import { downloadConteudoBase64 } from "../../../../infra/utils/DownloadFile";

const Documentos = ({ 
        codigoAnaliseProjeto, 
        documentos, 
        setIsLoading, 
        setOpenError, 
        setErrorMessage, 
        parecerDocumentos, 
        situacaoSolic,
        potenciaInstalada,
        unidadeConsumidora,
        setTypeAlert}) => {
    const { register } = useForm();
    const { getValues } = useFormContext();
    const [severity, setSeverity] = useState("info");
    const [openUpload, setOpenUpload] = useState(false);
    const [uploadMessage, setUploadMessage] = useState("");
    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);    

    const editavel = 
        situacaoSolic === 0 || situacaoSolic === 5  || parecerDocumentos === 3
            ? true 
            : false; 

    useEffect(() => {
        const handleDocumentos = () => {
            if(!documentos) return;
            
            documentos.map((doc) => {
                if(doc.Obrigatorio === 2) {
                    doc.CriterioAereo = (doc.ObrigAereo);
                    doc.CriterioSubterraneo = (doc.ObrigSubterraneo);
                    doc.CriterioMicrogeracao = (doc.ObrigMicrogeracao);
                    doc.CriterioMinigeracao = (doc.ObrigMinigeracao);
                }

                if(!doc.DefinirExtensoesValidas || doc.ExtensoesValidas.trim() === '') {
                    doc.ExtensoesValidas = '*';
                } 
            });
    
            setDocumentosObrigatorios(documentos);
        }

        handleDocumentos();
    }, [documentos, potenciaInstalada]);

    const handleCloseInfo = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenUpload(false);
        }

        setOpenUpload(false);
    }

    const handleUploadArquivos = async (e) => {
        let target = e.target;
        let file = target.files ? target.files[0] : null;

        if(!getValues("Id")) {
            setSeverity("warning");
            setOpenError(true);
            setErrorMessage("Para adicionar documentos, é necessário salvar a analise de projeto com informações válidas.");

            setIsLoading(false);
            return;
        }

        if (file === null) {
            setOpenError(true);
            return setErrorMessage("Selecione um arquivo");
        }

        try {
            const formData = new FormData();

            let nomeArquivoSeparadoPorPonto = file.name.split('.');
            const extensaoArquivo = nomeArquivoSeparadoPorPonto.pop();
            const nomeArquivo = nomeArquivoSeparadoPorPonto.join('.');
            const size = file.size / 1024;

            formData.append("Arquivo", file);
            formData.append("CodigoAnaliseProjeto", codigoAnaliseProjeto);

            const id = e.target.id;
            let codigos = id.split("-");

            if (codigos[5] != 0) {
                formData.append("CodigoDocumento", codigos[5]);    
            }

            if(codigos[7] !== '*' && !codigos[7].includes(extensaoArquivo)) {
                setOpenError(true);
                setIsLoading(false);
                setTypeAlert("error");
                setErrorMessage(`Não é possível adicionar arquivos com a extensão "${extensaoArquivo}".`);
                return;
            }

            formData.append("CodigoConfiguracaoDoc", codigos[3]);
            formData.append("CodigoClassificacaoDoc", codigos[1]);
            formData.append("NomeArquivo", nomeArquivo);
            formData.append("ExtensaoArquivo", extensaoArquivo);
            formData.append("TamanhoKbArquivo", Math.trunc(size));
            
            setOpenUpload(true);
            setSeverity("info");
            setUploadMessage("Upload de arquivo iniciado")

            setTimeout(() => {
                setOpenUpload(false);
            }, [3000]);

            setIsLoading(true);
            let response = await servAnaliseProjeto.InserirDocumentoNaConsulta(formData);

            documentosObrigatorios.map((documento) => {
                if (documento.Id == codigos[3]) {
                    documento.CodigoDocumento = parseInt(response.Content);
                    documento.NomeArquivo = nomeArquivo + '.' + extensaoArquivo;
                }
                return documento;
            })

            setOpenUpload(true);
            setSeverity("success");
            setUploadMessage("Arquivo enviado com sucesso");
            setIsLoading(false);
            setTimeout(() => {
                setOpenUpload(false);
            }, [1000]);

        } catch (err) {
            setOpenError(true);
            setIsLoading(false);
            setTypeAlert("error");
            let statusErrorMessage = err.response.status + " - " + err.response.statusText;

            setErrorMessage(err.response.data.Message ? err.response.data.Message : statusErrorMessage);
        }
    }

    const handleDownloadArquivo = async (event) => {
        event.preventDefault();

        let codigoDocumento = Number(event.currentTarget.value);

        if (!codigoDocumento) {
            setOpenError(true);
            return setErrorMessage("Não há documento vinculado para download.");
        }

        try {
            setIsLoading(true);

            let response = await servAnaliseProjeto.RealizarDownloadDocumento(codigoDocumento);
            downloadConteudoBase64(response.Content.Nome, response.Content.Arquivo);
            
            setUploadMessage("Arquivo enviado com sucesso");
            setIsLoading(false);
        } catch (err) {
            setOpenError(true);
            setIsLoading(false);
            let statusErrorMessage = err?.response?.status + " - " + err?.response?.statusText;

            setErrorMessage(err?.response?.data?.Message ? err?.response?.data?.Message : statusErrorMessage);
        }
    }

    const handleInputDocumentos = () => {
        return documentosObrigatorios && documentosObrigatorios.map((doc) => {
            // Se não é obrigatório por critério (2), sempre mostra
            if (doc.Obrigatorio !== 2) {
                return ContainerUpload(doc);
            }
            
            // Se é obrigatório por critério, mas DocumentoCriterioSelecionado não é true, sempre mostra
            if (!doc.DocumentoCriterioSelecionado) {
                return ContainerUpload(doc);
            }
            
            // Se DocumentoCriterioSelecionado é true e Obrigatorio é 2, usa ObrigatorioTipoProjeto
            if (doc.DocumentoCriterioSelecionado && doc.Obrigatorio === 2) {
                return doc.ObrigatorioTipoProjeto ? ContainerUpload(doc) : null;
            }
            
            // Caso padrão: mostra
            return ContainerUpload(doc);
        });
    }

    const handleRemoverArquivo = async (event) => {
        event.preventDefault();

        let codigoDocumento = Number(event.currentTarget.value);

        if (!codigoDocumento) {
            setOpenError(true);
            return setErrorMessage("Não há documento vinculado para download.");
        }

        try {
             setIsLoading(true);

            await servAnaliseProjeto.RemoverDocumento(codigoDocumento);
            
            setDocumentosObrigatorios((prev) =>
            prev.map((doc) => {
                if (doc.CodigoDocumento === codigoDocumento) {
                    return {
                        ...doc,
                        CodigoDocumento: null,
                        NomeArquivo: null
                    };
                }
                return doc;
            }));

            setOpenUpload(true);
            setSeverity("success");
            setUploadMessage("Arquivo excluído com sucesso");
            setIsLoading(false);
        }
        catch(err) {
            setOpenUpload(true);
            setIsLoading(false);
            setSeverity("error");
            let statusErrorMessage = err?.response?.status + " - " + err?.response?.statusText;

            setUploadMessage(err?.response?.data?.Message ? err?.response?.data?.Message : statusErrorMessage);
        }
    }

    const ContainerUpload = (doc) => {
        return (
            <div
                className={styles['upload-field']}
                key={`classifDoc-${doc.CodigoClassificacaoDoc}-configdoc-${doc.Id}-codigodoc-${doc.CodigoDocumento ?? 0}`}
            >
                <UploadInput
                    handleUploadArquivos={handleUploadArquivos}
                    handleDownloadArquivo={handleDownloadArquivo}
                    handleRemoverArquivo={handleRemoverArquivo}
                    id={`classifDoc-${doc.CodigoClassificacaoDoc}-configdoc-${doc.Id}-codigodoc-${doc.CodigoDocumento ?? 0}-extensoes-${doc.ExtensoesValidas}`}
                    label={doc.Descricao}
                    aprovado={doc.Aprovado}
                    situacaoSolic={situacaoSolic}
                    register={register}
                    registerName={doc.Descricao.replace(/\s/g, '-')}
                    obrigatorio={doc.Obrigatorio}
                    obrigatorioTipoProjeto={doc.ObrigatorioTipoProjeto}
                    codigoDocumento={doc.CodigoDocumento || 0}
                    disabled={!editavel}
                    nomeArquivo={doc.NomeArquivo}
                    extensoesValidas={doc.ExtensoesValidas}
                />
            </div>
        );
    };

    return (
        <div style={{ padding: "20px" }}>
            <div className={styles['cadastro-documentos']}>
                { handleInputDocumentos() }
            </div>
            <Snackbar open={openUpload} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={1000} onClose={handleCloseInfo}>
                <Alert onClose={handleCloseInfo} severity={severity} sx={{ width: '100%'}} >
                    {uploadMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}

export { Documentos }